import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import defaultTexts from '../../../texts/texts'
import CustomSwitchField from '../../_common/_form_fields/CustomSwitchField'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'

const PermissionsView = (props) => {
  const { billingPermissions } = props
  const theme = useTheme()

  const [allowManagement, setAllowManagement] = useState(false)
  const [configsRead, setConfigsRead] = useState(false)
  const [analyticsRead, setAnalyticsRead] = useState(false)
  const [depositsRead, setDepositsRead] = useState(false)
  const [depositsUpdate, setDepositsUpdate] = useState(false)
  const [servicesRead, setServicesRead] = useState(false)
  const [servicesCreate, setServicesCreate] = useState(false)
  const [servicesUpdate, setServicesUpdate] = useState(false)
  const [servicesDelete, setServicesDelete] = useState(false)
  const [pricesRead, setPricesRead] = useState(false)
  const [pricesUpdate, setPricesUpdate] = useState(false)
  const [pricesCreate, setPricesCreate] = useState(false)

  const fieldBoxStyle = {
    padding: '12px 0px'
  }

  const switchLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
  }

  const checkboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const checkboxLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
  }

  useEffect(() => {
    const isPermission = (section, permission) => {
      let result = false

      if (billingPermissions && billingPermissions.config_params && billingPermissions.config_params.custom_admin_ui && billingPermissions.config_params.custom_admin_ui.length > 0) {
        const section_object = billingPermissions.config_params.custom_admin_ui.find(item => item.section === section)
        if (section_object && section_object.permissions && section_object.permissions.length > 0 && section_object.permissions.includes(permission)) {
          result = true
        }
      }

      return result
    }
    
    if (billingPermissions && billingPermissions.config_params && billingPermissions.config_params.visible_to_service && billingPermissions.config_params.visible_to_service.length > 0 && billingPermissions.config_params.visible_to_service.includes('custom_admin_ui')) {
      setAllowManagement(true)
    } else {
      setAllowManagement(false)
    }

    setConfigsRead(isPermission('billing_configs', 'read'))
    setAnalyticsRead(isPermission('billing_analytics', 'read'))
    setDepositsRead(isPermission('billing_deposits', 'read'))
    setDepositsUpdate(isPermission('billing_deposits', 'update'))
    setServicesRead(isPermission('billing_services', 'read'))
    setServicesCreate(isPermission('billing_services', 'create'))
    setServicesUpdate(isPermission('billing_services', 'update'))
    setServicesDelete(isPermission('billing_services', 'delete'))
    setPricesRead(isPermission('billing_prices', 'read'))
    setPricesUpdate(isPermission('billing_prices', 'update'))
    setPricesCreate(isPermission('billing_prices', 'create'))
  }, [billingPermissions])

  return (
    <>
      <Box sx={fieldBoxStyle}>
        <Stack
          direction='row'
          justifyContent='center'
        >
          <CustomSwitchField
            label={defaultTexts.allowBillingManagementText}
            checked={allowManagement}
            handleChange={() => {}}
            sxLabel={switchLabelStyle}
          />
        </Stack>
      </Box>

      <Grid container>
        <Grid size={{ lg: 4 }}>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.displayBillingServiceConfiguration}
              checked={configsRead}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.displayBillingServiceAnalytics}
              checked={analyticsRead}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.displayUserAccounts}
              checked={depositsRead}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.updateUserAccounts}
              checked={depositsUpdate}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

        </Grid>
        <Grid size={{ lg: 5 }}>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.displayOpenStackServiceConfiguration}
              checked={servicesRead}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.addNewOpenStackServiceToBilling}
              checked={servicesCreate}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.updateOpenStackServiceConfiguration}
              checked={servicesUpdate}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.deleteOpenStackServiceFromBilling}
              checked={servicesDelete}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

        </Grid>
        <Grid size={{ lg: 3 }}>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.displayPrices}
              checked={pricesRead}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.updatePrices}
              checked={pricesUpdate}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

          <Box>
            <CustomCheckboxField
              label={defaultTexts.addNewPrices}
              checked={pricesCreate}
              handleChange={() => {}}
              sx={checkboxStyle}
              sxLabel={checkboxLabelStyle}
            />
          </Box>

        </Grid>
      </Grid>
    </>
  )
}

export default PermissionsView